import React, { ReactNode, SFC } from 'react'

import './top-bar.scss'

type Props = {
  children: {
    navigation?: ReactNode
    buttons?: ReactNode
  }
}

export const TopBar: SFC<Props> = ({ children }) => {
  return (
    <div className="top-bar" data-test="top-bar-navigation">
      {children.navigation && (
        <div className="top-bar__navigation" data-test="navigations">
          {children.navigation}
        </div>
      )}
      {children.buttons && (
        <div className="top-bar__buttons" data-test="buttons">
          {children.buttons}
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/components/top-bar.tsx